import { withStyles } from "@mui/styles";
import { ReactNode } from "react";

const styles = function styles() {
  return {
    "@global": {
      html: {
        boxSizing: "border-box",
      },
      "*, *::before, *::after": {
        boxSizing: "inherit",
      },
    },
  };
};

function CssBaseline({ children }: { children?: ReactNode }) {
  return <>{children}</>;
}

export default withStyles(styles, {
  name: "CssBaseline",
})(CssBaseline);
